export const SmashEnvToken = "SMASH_TOKEN";
export const SmashEnvRegion = "SMASH_REGION";
